import { useMemo } from 'react'

import { PAYMENT_PROVIDERS } from '@constants/paymentProviders'
import { useOxxo } from '@pages/Checkout/hooks/Payment/Common/useOxxo'

export const useOxMethods = () => {
  const ox = useOxxo({ provider: PAYMENT_PROVIDERS.OXXO_DIRECT })

  return useMemo(() => ({ ox }), [ox])
}
